import { createSlice } from "@reduxjs/toolkit";

export const layoutSlice = createSlice({
    name: 'layout',
    initialState: {
        sidebarShow: true,
    },
    reducers: {
        changeSlider: (state) => {
            state.sidebarShow = !state.sidebarShow
        },
    }
})

export const { changeSlider } = layoutSlice.actions

export default layoutSlice.reducer